import memoize from 'lru-memoize';
import {linuxUserRules, createValidator, required, maxLength, email, noSpecialChars, noSpaces, minLength} from 'utils/validation';

const loginValidation = createValidator({
	username: [required],
  password: [required],
});



export default memoize(10)(loginValidation);
